import actions from '../../actionTypes';

export default (tag, areaId) => {
  return {
    type: actions.DELETE_TAG,
    tag,
    areaId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/deleteTag.js